import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { InfoMessage, Input, LoginFooter } from 'components';
import { Button, Text } from 'components';
import axios from 'axios';
import { Message } from 'types/message';
import { InformationCircleOutlineIcon } from 'assets/svgs';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>('');
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const [token, setToken] = useState<string>(''); 
  const [newPasswordError, setNewPasswordError] = useState<string>('');
  const [confirmPasswordError, setConfirmPasswordError] = useState<string>('');
  const [messageArray, setMessageArray] = useState<Message[]>([]);
  const [messageArrayCount, setMessageArrayCount] = useState(0);

  const nav = useNavigate();

  //영문/숫자/특수문자 최소 한 개 이상으로 구성 최소 8자 이상
  const passwordRegexp = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/);
  const location = useLocation();

  useEffect(() => {

    let newPasswordError = '';
    let confirmPasswordError = '';

    // 입력이 시작된 경우에만 검사를 수행
    if (newPassword || confirmNewPassword) {
      let error = '';
      if (newPassword && !passwordRegexp.test(newPassword)) {
        newPasswordError = 'Password must be at least 8 characters and include letters, numbers, and special characters.';
      } else if (newPassword !== confirmNewPassword) {
        error = 'Passwords do not match.';
      }

      setNewPasswordError(error);
      setIsButtonDisabled(error !== '');
    } 
    // confirmNewPassword 필드의 에러 검사
    if (confirmNewPassword) {
      if (newPassword !== confirmNewPassword) {
        confirmPasswordError = 'Passwords do not match.';
      }
    }

    setNewPasswordError(newPasswordError);
    setConfirmPasswordError(confirmPasswordError);

    // 모든 조건이 만족되면 버튼을 활성화
    setIsButtonDisabled(newPasswordError !== '' || confirmPasswordError !== '');

  }, [newPassword, confirmNewPassword]);


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    }
  }, [location.search]); 

  function onClickDeleteButton(index: number) {
    setMessageArray((prev) => prev.filter((message: any) => message.index !== index));
  }


  const onClickPwButton = async () => {
    // 비밀번호 변경 요청
    try {
      const response = await axios.post('/api/member/passwordResetEnd', {
        newPassword, token 
      });
      console.log('Password reset successful:', response.data);
      setMessageArray((prev) => [
        ...prev,
        {
          index: messageArrayCount,
          icon: <InformationCircleOutlineIcon />,
          text: `Your password has been successfully changed.`
        }
      ]);
      setTimeout(() => onClickDeleteButton(messageArrayCount), 2000);
      setMessageArrayCount((prev) => prev + 1);
      setTimeout(() => {
        nav('/login');
      }, 3000);
    } catch (error) {
      if (error instanceof AxiosError) {
        const status = error.response?.status;
        const method = (error.response?.data as any)?.method;
        if (status === 400 && method === 'SAME_PASSWORD') {
          setNewPasswordError('The new password must be different from the current password.');
          setMessageArray((prev) => [
            ...prev,
            {
              index: messageArrayCount,
              icon: <InformationCircleOutlineIcon />,
              bgClassName: 'bg-red-600',
              text: 'The new password is the same as the current password.'
            }
          ]);
          setTimeout(() => onClickDeleteButton(messageArrayCount), 2000);
          setMessageArrayCount((prev) => prev + 1);
          return;
        }
      }
      console.error('Error resetting password:', error);
    }
  };

  return (
    <div className="flex h-screen max-h-screen w-screen flex-col bg-white">
      <main className="flex w-full flex-1 items-center justify-center">
        <div className="flex w-80 flex-col items-center">
          <Text className="mb-6" size="heading2" weight="medium">
            Reset password
          </Text>

            <form className="mb-6 flex w-full flex-col gap-6">
            <Input
              inputClassName="bg-white h-10"
              label="New password"
              type="password"
              value={newPassword}
              setValue={setNewPassword}
              errorMessage={newPasswordError}
            />
            <Input
              inputClassName="bg-white h-10"
              label="Confirm new password"
              type="password"
              value={confirmNewPassword}
              errorMessage={confirmNewPassword && newPassword !== confirmNewPassword ? 'Passwords do not match.' : ''}
              setValue={setConfirmNewPassword}
            />
            </form>
            <Button
              className="h-10 w-full items-center justify-center"
              text="Reset password"
              type="blue"
              disabled={isButtonDisabled}
              onClick={onClickPwButton}
            />
          </div>
          <InfoMessage messageArray={messageArray} onClickDelete={onClickDeleteButton} />
      </main>
      <LoginFooter />
    </div>
  );
};

export default ResetPassword;
